export default __webpack_public_path__ + "static/media/breach_nav.72149962.svg";